import React, {useState} from "react";
import PropTypes from "prop-types";
import {Divider, ListItemIcon, ListItemText, MenuItem, Menu} from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import NetworkCheck from "@mui/icons-material/NetworkCheck";
import Palette from "@mui/icons-material/Palette";
import Person from "@mui/icons-material/Person";
import PowerSettingsNew from "@mui/icons-material/PowerSettingsNew";
import ReceiptOutlined from "@mui/icons-material/ReceiptOutlined";
import UpgradeProfileMenuBanner from "../../upgrade/UpgradeProfileMenuBanner";
import {useNavigate} from "react-router";
import {statusPage} from "../../../resources/environment";
import {useRegScoutCore} from "../../../resources/RegScoutCoreProvider";
import {useTheme} from "../../../resources/ConsolidatedThemeProvider";
import {map} from "underscore";

const themeOptions = [
  {text: "Light", value: "light"},
  {text: "Dark", value: "dark"},
];

const ProfileMenuOptions = ({onClose}) => {
  const {logout} = useRegScoutCore();
  const navigate = useNavigate();
  const {activeTheme, toggleActiveTheme} = useTheme();
  const currentThemeName = activeTheme?.palette?.themeName;
  const [themeAnchorEl, setThemeAnchorEl] = useState(null);

  const handleLogout = () => {
    logout();
    onClose && onClose();
  };

  const handleNavigate = (url) => {
    navigate(url);
    onClose && onClose();
  };

  const handleStatus = () => {
    window.open(statusPage);
    onClose && onClose();
  };

  const handleThemeSelect = (themeName) => {
    toggleActiveTheme(themeName);
    setThemeAnchorEl(null);
    onClose && onClose();
  };

  return (
    <>
      <UpgradeProfileMenuBanner handleNavigate={handleNavigate} />
      <MenuItem sx={{marginTop: 1}} onClick={(e) => setThemeAnchorEl(e.currentTarget)}>
        <ListItemIcon
          sx={(theme) => ({marginRight: 1, padding: 0, color: theme.palette.layout.icon.color})}
        >
          <Palette fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Themes" />
        <ChevronRight fontSize="small" />
      </MenuItem>
      <Menu
        anchorEl={themeAnchorEl}
        open={!!themeAnchorEl}
        onClose={() => setThemeAnchorEl(null)}
        anchorOrigin={{vertical: "top", horizontal: "right"}}
        transformOrigin={{vertical: "top", horizontal: "left"}}
        PaperProps={{className: "sidebar-submenu"}}
      >
        {map(themeOptions, (option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleThemeSelect(option.value)}
            selected={currentThemeName === option.value}
          >
            <ListItemText primary={option.text} />
          </MenuItem>
        ))}
      </Menu>
      <Divider />
      <MenuItem onClick={() => handleNavigate("/profile")}>
        <ListItemIcon
          sx={(theme) => ({marginRight: 1, padding: 0, color: theme.palette.layout.icon.color})}
        >
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Manage Profile" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => handleNavigate("/subscription")}>
        <ListItemIcon
          sx={(theme) => ({marginRight: 1, padding: 0, color: theme.palette.layout.icon.color})}
        >
          <ReceiptOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Manage Subscription" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleStatus}>
        <ListItemIcon
          sx={(theme) => ({marginRight: 1, padding: 0, color: theme.palette.layout.icon.color})}
        >
          <NetworkCheck fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="BreachRx Status" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon
          sx={(theme) => ({marginRight: 1, padding: 0, color: theme.palette.layout.icon.color})}
        >
          <PowerSettingsNew fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </MenuItem>
    </>
  );
};

ProfileMenuOptions.propTypes = {
  onClose: PropTypes.func,
};

export default ProfileMenuOptions;
